// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2e3W2","footer":"ModalUpdate_footer__32Tp2"};